import { Fade, InputAdornment, TextField } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import React from 'react';
import { useStateBoolean } from '../../hooks/useStateBool';
import { matchNullOrEmptyToUndefined } from '../../utils/matchNullOrEmptyToUndefined';

interface IProps {
	label: string;
	value: number | undefined;
	disabled?: boolean;
	onChange: (val: number | undefined) => void;
	style?: React.CSSProperties;
}

export const IntegerTextField = ({ label, value, onChange, disabled = false, style }: IProps) => {
	const [isHovered, enter, leave] = useStateBoolean(false);

	return (
		<TextField
			style={style}
			onMouseEnter={enter}
			onMouseLeave={leave}
			variant='filled'
			fullWidth
			value={value !== undefined ? value : null} //trick to render it
			label={label}
			onChange={e => onChange(matchNullOrEmptyToUndefined<number>(e.target.value))}
			type='text'
			inputProps={{ pattern: '[0-9]*' }}
			InputProps={{
				endAdornment: (
					<InputAdornment position='end'>
						<Fade in={isHovered && value !== undefined && disabled === false}>
							<CancelIcon
								color='primary'
								style={{ cursor: 'pointer' }}
								onClick={() => onChange(undefined)}
							/>
						</Fade>
					</InputAdornment>
				),
			}}
		/>
	);
};
